import React, { useState, useEffect, useContext } from "react";
import Button from '@mui/material/Button';
import CircularProgress from "@mui/material/CircularProgress";
import './addPrimarySkill.css';
import Modal from "../../components/modal/";
import AddSkillForm from "../../forms/addSkillForm";
import getAllDomains from "../../apis/getAllDomains";
import getAllSkills from "../../apis/getAllSkills";
import { UserTypeContext } from "../../AppRoute";
import DataTable from "../../components/DataTable/DataTable";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import Tooltip from "@mui/material/Tooltip";
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import UnauthorizedAccess from "../../components/UnauthorizedAccess/UnauthorizedAccess";
const AddPrimarySkill = ({ idContextTest }) => {
  const history = useNavigate();
  const { userType, userIdType } = useContext(UserTypeContext);
  const [allDomains, setAllDomains] = useState([]);
  const [skillId, setSkillId] = useState("");
  const [modalIsOpen, setmodalIsOpen] = useState(false);
  const [isDataLoaded, setisDataLoaded] = useState(false);
  const [allPublicSkill, setallPublicSkill] = useState([]);
  const [editSkill, setEditSkill] = React.useState(null);
  const activityOptions = [
    { label: 'All', value: '' },
    { label: 'True', value: 'true' },
    { label: 'False', value: 'false' }
  ]
  function isActiveFilterFn(row, columnId, filterValue) {
    if (!filterValue) return true; // no filter
    const rowValue = row.getValue(columnId);
    const filterValLower = filterValue.toLowerCase();
    if (filterValLower === 'true') return rowValue === true;
    if (filterValLower === 'false') return rowValue === false;
    return true;
  }

  const getIsActiveFilterValue = (column) => {
    const filterValue = column.getFilterValue();
    const activityOptions = [
      { label: 'All', value: '' },
      { label: 'True', value: 'true' },
      { label: 'False', value: 'false' }
    ];
    let value = activityOptions.find(opt => opt.value === filterValue);
    if (!value) {
      value = { label: 'All', value: '' };
    }
    return value;
  }

  const clientData = [];

  const columns = [
    {
      id: "edit",
      header: "Edit",
      cell: ({ row }) => (
        <Button
          variant="contained"
          color="primary"
          onClick={() => handleEdit(row.original)}
          className="edit-button-add-primary-skill"
        >
          Edit
        </Button>
      ),
      size: 80,
      enableSorting: false,
      enableColumnFilter: false,
    },
    {
      accessorKey: "name",
      header: "Skill",
      size: 200,
      enableSorting: true,
      enableColumnFilter: true,
      filterFn: 'includesString',
    },
    {
      accessorKey: "domain.name",
      header: "Domain",
      size: 400,
      enableSorting: true,
      enableColumnFilter: true,
      filterFn: 'includesString',
    },
    {
      accessorKey: "isActive",
      header: "Is Active",
      size: 80,
      enableSorting: true,
      enableColumnFilter: true,
      filterFn: isActiveFilterFn,
      cell: ({ getValue }) => (getValue() ? "True" : "False"),
      Filter: ({ column }) => (
        <Autocomplete
          disableClearable
          className='isActiveFilter-autocomplete'
          options={activityOptions}
          value={getIsActiveFilterValue(column)}
          onChange={(event, newValue) => {
            column.setFilterValue(newValue ? newValue.value : '');
          }}
          getOptionLabel={(option) => option.label}
          renderInput={(params) => (
            <TextField
              {...params}
              size="small"
            />
          )}
          sx={{ width: '100%' }}
        />
      )
    },
  ]

  useEffect(() => {
    const getData = async () => {
      try {
        await getSkills();
        const allDomainResponse = await getAllDomains();
        if (allDomainResponse.status === 200) {

          setisDataLoaded(true);
          setAllDomains(
            allDomainResponse.data ? allDomainResponse.data.data.filter((item) => item.isActive === true) : []
          );
          setisDataLoaded(true);
        }

      } catch (e) {
        console.log(e);
        setisDataLoaded(true);
      } finally {
        setisDataLoaded(true);
      }
    };
    if (userType === "Admin") {
      getData();
    } else {
      setisDataLoaded(true);
    }
  }, []);

  const openModal = (id) => {
    setmodalIsOpen(true);
  };
  const handleEdit = (skill) => {
    if (skill) {
      setEditSkill(skill);
      setmodalIsOpen(true);
    }
  };
  const closeModal = () => {
    setmodalIsOpen(false);
    //Would like to keep from seeing flashing "Add" on close of Edit
    setSkillId("");
    setEditSkill(null);
  };
  const getSkills = async () => {

    const allSkillResponse = await getAllSkills();
    setallPublicSkill(allSkillResponse.data.data.filter((i) => !i.isPrivate));

  };
  const refreshSkills = async () => {
    await getSkills();
  };
  const closeSaveModal = async () => {
    closeModal();
    refreshSkills();
  };


  const btnGreen = {
    color: "#fff",
    backgroundColor: "#1885e6",
    border: "none",
    padding: "7px 23px 7px 23px",
    float: "right",
  };

  const goToDashboard = () => {
    history("/admin-home");
  };

  return (
    <>

      <div className="main_container_addprimarySkill">
        {!isDataLoaded ? (
          <div className="row padding_80 text-center">
            <CircularProgress />
          </div>
        ) : (
          <>
            {userType === "Admin" ? (
              <>
                {/* <div className="card talent_community"> */}

                <div className="communityHeader_addPrimarySkill">
                  <div className="header-content">
                    <div className="goBackButton" onClick={(e) => goToDashboard(e)}>
                      <Tooltip title="Go Back to Dashboard" placement="bottom">
                        <ArrowBackIcon sx={{ fontSize: 20 }} />
                      </Tooltip>
                    </div>
                    <div className="communityTitle">Skills</div>
                  </div>
                  <Button
                    variant="outlined"
                    style={btnGreen}
                    onClick={openModal}
                  >
                    Add Skill
                  </Button>
                </div>

                <div className="my_talent_search_container Skill_serch_right_wrapper">
                </div>

                <div>
                  <div className="tabs">
                    <div className="tab my_talent_table_design"></div>

                    <DataTable
                      data={allPublicSkill}
                      columns={columns}
                      isLoading={!isDataLoaded}
                      initialColumnFilters={[
                        {
                          id: 'isActive',
                          value: 'true'
                        }
                      ]}
                    />

                  </div>
                </div>
                {/* </div> */}
              </>
            ) : userType === "" ? (<div className="row padding_80 text-center">
              <p className="fs-semi-bold fs-40 f-color">
                Loading...
              </p>
            </div>) : (
              <UnauthorizedAccess />
            )}
          </>
        )
        }
      </div >
      <Modal open={modalIsOpen}>
        <AddSkillForm
          userIdType={userIdType}
          domainOptions={allDomains}
          onCancel={closeModal}
          onSave={closeSaveModal}
          skillId={skillId}
          clientData={clientData}
          editSkill={editSkill}
        />
      </Modal>
    </>
  );
};
export default AddPrimarySkill;
